import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';

export default class CommunicationsRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;

  beforeModel(): void | Promise<unknown> {
    if (!this.abilities.can('visit communications')) {
      void this.router.transitionTo('unauthorized');
    }
  }

  model(): void {
    return;
  }
}
